import { render } from "./BaseAddressForm.vue?vue&type=template&id=e36c8268"
import script from "./BaseAddressForm.js?vue&type=script&lang=js"
export * from "./BaseAddressForm.js?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./BaseAddressForm.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FPageCheckout%2FBillingDetails%2FBaseAddressForm%2FBaseAddressForm.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__